import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DynamicConfigService } from '@cleverconnect/ngx-dynamic-config';
import { Config } from '../../config/config';
import { ItemsAction } from 'src/app/share/account-menu-selector/items-action';

import { User } from '../../../auth/user';

@Component({
  selector: 'app-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss'],
})
export class CommonHeaderComponent implements OnInit {
  @Input()
  public title: string;
  @Input()
  public previousUrl: string;
  @Input()
  public tag: string;
  @Input()
  public hasCloseButton: boolean = true;
  @Input()
  public hasMenu: boolean = true;
  @Input()
  public backgroundClasses: string;
  public colorBackground: string = '';
  public hasScrolled: boolean = false;
  public subscription: any;
  public redirectV1: string;
  public me: User = this.route.snapshot.data?.me;
  public itemsMenuHeader: ItemsAction[] = [];

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private configService: DynamicConfigService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    if (!!this.route.snapshot.data.panel) {
      this.backgroundClasses = 'panel';
    }
    // The user menu shows the top bar behind it, whose blue is the same on every page
    this.colorBackground = 'border-0 bg-transparent';
    this.itemsMenuHeader = this.userMenu();
  }

  /** Same menu as account v1: the account settings, the administration and the logout */
  public userMenu(): ItemsAction[] {
    const items: ItemsAction[] = [
      {
        index: 1,
        translate: 'HEADER.MENU.SETTINGS',
        icon: 'settings',
        action: () => (this.document.location.href = `${this.configService.get<Config>().v1Url}/settings`),
      },
    ];

    if (this.me?.isCsm || this.me?.isAdmin || this.me?.isAdminTeam) {
      items.push({
        index: 2,
        translate: 'NAVIGATION.ADMIN',
        image: 'assets/images/user-menu-admin.svg',
        action: () => this.router.navigate(['panel']),
      });
    }

    items.push({
      index: 3,
      translate: 'PRIVATE_SHARE.HEADER.MENU.LOGOUT',
      icon: 'power_settings_new',
      action: () => this.authService.logout(),
    });

    return items;
  }

  public runActionItem(item: ItemsAction): void {
    item.action();
  }
}
